import MagnifyingGlassDollarsIcon from './MagnifyingGlassDollarsIcon'

export default MagnifyingGlassDollarsIcon
